import 'bootstrap';
import { Tooltip } from 'bootstrap';

import './components/calendar';
import './components/tender';
import './components/mustConfirm';
import './components/datepicker';
import './components/inputs';
import './winners-autofill';
// import './components/chart';

import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

jQuery(document).ready(function () {
    jQuery(".select2--default").select2({ width: '100%' });
});


function tooltip() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    })
}

document.addEventListener('DOMContentLoaded', tooltip);
